import React, { ComponentType } from 'react';
import { IconProps } from '../../icons/IconBase';

interface ToastIconProps {
  icon?: ComponentType<IconProps>;
  size: number;
  className: string;
}

const ToastIcon: React.FC<ToastIconProps> = ({
  icon: Icon,
  size,
  className,
}) => {
  if (!Icon) return null;

  return (
    <div className={className}>
      <Icon width={size} height={size} />
    </div>
  );
};

export default ToastIcon;
